import React, { useState, useContext, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs } from '@mui/material';
import TabPanel from '../../components/TabPanel';
// Providers
import { DashboardProvider } from '../Dashboard/useDashboard';
// Context
import AppConst from '../../components/AppLayout/const';
// Components
import CallPerformanceDashboard from '../CallPerformanceDashboard';
import ProductUtilizationDashboard from '../ProductUtilizationDashboard';
import ProductSamplingDashboard from '../ProductSamplingDashboard';
import useStore from '../../states/store';

export default function CRMDashboard() {
  const { onSetTitle } = useContext(AppConst.AppContext);
  const auth = useStore((state) => state.auth);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabName, setActiveTabName] = useState(false);

  onSetTitle('CRM Dashboard');

  const callPerformanceAccess = [
    'KASM',
    'KASOM',
    'KASROM',
    'KASH',
    'SAM',
    'RSM',
    'NSM-SPARTAN',
    'admin',
    'COO',
    'EXECUTIVE',
  ];
  const productUtilAccess = [
    'KASM',
    'KASOM',
    'KASROM',
    'KASH',
    'SAM',
    'RSM',
    'NSM-SPARTAN',
    'admin',
    'PM',
    'GPM',
    'COO',
    'EXECUTIVE',
  ];

  const productSamplingAccess = [
    'KASM',
    'KASOM',
    'KASROM',
    'KASH',
    'SAM',
    'RSM',
    'NSM-SPARTAN',
    'admin',
    'PM',
    'GPM',
    'COO',
    'EXECUTIVE',
  ];

  const handleDefaultPage = () => {
    if (callPerformanceAccess.includes(auth.designation)) {
      setActiveTab(0);
      setActiveTabName('cdpActive');
      return;
    }

    if (productUtilAccess.includes(auth.designation)) {
      setActiveTab(1);
      setActiveTabName('pudActive');
      return;
    }

    if (productSamplingAccess.includes(auth.designation)) {
      setActiveTab(2);
      setActiveTabName('psdActive');
    }
  };

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
    setActiveTabName(event.target.name);
  };

  useEffect(() => {
    handleDefaultPage();
  }, []);
  return (
    <DashboardProvider>
      <Box padding={4}>
        <Grid container spacing={2}>
          <Grid xs={12} sm={12} md={12}>
            <Box sx={{ backgroundColor: '#fff' }} mt={4}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={activeTab}
                  onChange={handleChangeActiveTab}
                  aria-label='basic tabs example'
                >
                  {callPerformanceAccess.includes(auth.designation) ? (
                    <Tab
                      label='Call Performance'
                      id='call-performance'
                      aria-controls='call-performance'
                      name='cdpActive'
                    />
                  ) : (
                    ''
                  )}
                  {productUtilAccess.includes(auth.designation) ? (
                    <Tab
                      label='Product Utilization'
                      id='product-utilization-tab'
                      aria-controls='product-utilization-tab'
                      name='pudActive'
                    />
                  ) : (
                    ''
                  )}
                  {productSamplingAccess.includes(auth.designation) ? (
                    <Tab
                      label='Product Sampling'
                      id='product-sampling-tab'
                      aria-controls='product-sampling-tab'
                      name='psdActive'
                    />
                  ) : (
                    ''
                  )}
                </Tabs>
              </Box>
              <TabPanel value={activeTab} index={activeTab}>
                {activeTabName === 'cdpActive' &&
                callPerformanceAccess.includes(auth.designation) ? (
                  <CallPerformanceDashboard />
                ) : (
                  ''
                )}
                {activeTabName === 'pudActive' && productUtilAccess.includes(auth.designation) ? (
                  <ProductUtilizationDashboard />
                ) : (
                  ''
                )}
                {activeTabName === 'psdActive' &&
                productSamplingAccess.includes(auth.designation) ? (
                  <ProductSamplingDashboard />
                ) : (
                  ''
                )}
              </TabPanel>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </DashboardProvider>
  );
}
